// extracted by mini-css-extract-plugin
export default {"item_name":"styles_item_name__YnudV"};